/* eslint-disable complexity */
import { Station } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { stepperIndicatorVariants, type StepperStatus } from '@e2n/ui/v2';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';

export function StationContainer({
  children,
  showGradient = false,
  station,
}: {
  children: ReactNode;
  showGradient?: boolean;
  station?: Station;
}) {
  const status: StepperStatus = station?.istAbgeschlossen
    ? 'completed'
    : station?.istAktiv
      ? 'active'
      : 'inactive';

  const lineClassName =
    status === 'completed'
      ? 'bg-brand-red-200'
      : showGradient
        ? 'bg-linear-to-b from-neutrals-v2-500 to-transparent'
        : 'bg-neutrals-v2-500';

  return (
    <div className="grid grid-cols-[36px_1fr] gap-4">
      <div className="flex flex-col items-center h-full">
        {status === 'completed' ? (
          <span
            className={stepperIndicatorVariants({
              variant: 'prominent',
              status,
            })}>
            <FontAwesomeIcon icon={faCheck} />
          </span>
        ) : (
          <span
            className={stepperIndicatorVariants({
              variant: 'default',
              status,
            })}
          />
        )}
        <div className={`h-full w-0.5 ${lineClassName}`} />
      </div>
      {children}
    </div>
  );
}
